export const useFeatureFlags = () => {
  const currentSite = inject("currentSite")

  const inAgeRestrictedLocation = inject("inAgeRestrictedLocation")
  const ageRestrictedSites = [
    "bbcpie",
    "cum4k",
    "girlcum",
    "lubed",
    "passionhd",
    "povd",
    "pornplus",
    "tiny4k",
  ]

  // Helper to normalize site names by removing hyphens/dashes
  const normalizeSiteName = (name) => name.replace(/-/g, "")

  const ageRestrictionFlag =
    inAgeRestrictedLocation &&
    ageRestrictedSites.includes(normalizeSiteName(currentSite.value.slug))

  return { ageRestrictionFlag }
}
